module.exports = __webpack_public_path__ + "static/media/whitethirdsquare.48db247c.png";